import type { CityConfig } from "../city-template/types";

export const franklinNhConfig: CityConfig = {
  city: "Franklin",
  state: "New Hampshire",
  stateAbbr: "NH",
  slug: "franklin-nh",
  route: "/cities/franklin-nh",
  title: "Emergency Passport Franklin, NH | Fast Passport Renewal & Expedited Help",
  metaDescription: "Emergency passport and expedited passport services in Franklin, NH — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Merrimack County and central New Hampshire travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Franklin, NH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Franklin and central New Hampshire travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Franklin%20New%20Hampshire%20scenic%20view%20with%20the%20historic%20Daniel%20Webster%20birthplace%20and%20the%20junction%20of%20the%20Pemigewasset%20and%20Winnipesaukee%20Rivers%2C%20charming%20New%20England%20small%20town%20with%20red%20barns%20and%20white%20churches%2C%20warm%20summer%20afternoon%20light%20with%20lush%20green%20trees%2C%20clean%20and%20inviting%20rural%20scene%2C%20no%20visible%20text%20or%20people%2C%20professional%20landscape%20photography%2C%20warm%20earth%20tones%20and%20soft%20blue%20sky%2C%20photorealistic%2C%20New%20England%20river%20town%20charm&width=1800&height=700&seq=franklin-nh-hero-001&orientation=landscape",
  heroImageAlt: "Franklin New Hampshire scenic view with the Pemigewasset and Winnipesaukee Rivers junction and historic Daniel Webster birthplace",
  geoPosition: "43.4442;-71.6463",
  geoPlacename: "Franklin, New Hampshire",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "5 Customs House St, Boston, MA 02103",
    distance: "Located in downtown Boston — approximately 1.5 to 2 hours from Franklin via I-93",
  },
  nearbyCitiesZips: [
    { name: "Franklin", zips: "03235" },
    { name: "Tilton", zips: "03276" },
    { name: "Northfield", zips: "03276" },
    { name: "Sanbornton", zips: "03269" },
    { name: "Hill", zips: "03243" },
    { name: "Andover", zips: "03216" },
    { name: "Salisbury", zips: "03268" },
    { name: "Boscawen", zips: "03303" },
    { name: "Canterbury", zips: "03224" },
    { name: "Loudon", zips: "03307" },
    { name: "Pittsfield", zips: "03263" },
    { name: "Epsom", zips: "03234" },
    { name: "Chichester", zips: "03258" },
    { name: "Pembroke", zips: "03275" },
    { name: "Concord", zips: "03301–03305" },
    { name: "Laconia", zips: "03246" },
    { name: "Belmont", zips: "03220" },
    { name: "Gilford", zips: "03249" },
    { name: "New Hampton", zips: "03256" },
    { name: "Wilmot", zips: "03287" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent central New Hampshire departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Manchester", route: "/cities/manchester" },
    { name: "Nashua", route: "/cities/nashua" },
    { name: "Concord", route: "/cities/concord-nh" },
    { name: "Laconia", route: "/cities/laconia" },
    { name: "Lebanon", route: "/cities/lebanon" },
    { name: "Plymouth", route: "/cities/plymouth" },
    { name: "Tilton", route: "/tilton" },
    { name: "Hooksett", route: "/cities/hooksett" },
    { name: "Merrimack", route: "/cities/merrimack" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Franklin remotely via secure courier. We do not have a walk-in office in Franklin — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for central New Hampshire travelers.",
  fpcOfficeDistance: "Serving all of Merrimack County and central New Hampshire",
  serviceAreaIntro: "From Franklin's historic Daniel Webster district to the Tilton border, from the Pemigewasset River waterfront to the Northfield area — Fast Passport Center serves the entire Franklin community. We regularly help travelers from Tilton, Northfield, Sanbornton, and Hill get their passports fast.",
  nearbyCitiesIntro: "We serve all Franklin neighborhoods and nearby central New Hampshire cities including Tilton, Northfield, Sanbornton, Hill, Andover, Salisbury, Boscawen, Canterbury, Loudon, Pittsfield, Epsom, Chichester, Pembroke, Concord, Laconia, Belmont, Gilford, New Hampton, and Wilmot. If you are in the greater Franklin area, we have you covered.",
  howItWorksIntro: "Most Franklin travelers complete everything online and ship documents overnight. No need to drive to Boston — our courier handles the in-person delivery for you.",
  mistakesIntro: "With easy access to Laconia Municipal Airport (LCI) and Manchester-Boston Regional (MHT), central New Hampshire travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Franklin and central New Hampshire travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Franklin? Here are the most common ones we hear from central New Hampshire travelers.",
  statePageRoute: "/states/new-hampshire",
  statePageName: "New Hampshire",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Franklin international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Linda H.",
      location: "Franklin, NH",
      rating: 5,
      text: "My family vacation to Mexico was in 6 days and my daughter's passport was expired. Fast Passport Center got her a new one in 48 hours. The process was so smooth.",
      service: "Child Passport",
    },
    {
      name: "Steven M.",
      location: "Tilton, NH",
      rating: 5,
      text: "Needed to renew for a business trip to Toronto. They reviewed my documents and I had my passport in 3 days. Great service for the Lakes Region area.",
      service: "Passport Renewal",
    },
    {
      name: "Barbara K.",
      location: "Northfield, NH",
      rating: 5,
      text: "Lost my passport before a trip to Ireland. I was panicking. They calmed me down, explained the process, and got my replacement in 2 days. Thank you.",
      service: "Lost Passport",
    },
    {
      name: "Thomas J.",
      location: "Sanbornton, NH",
      rating: 5,
      text: "As a frequent traveler from the Lakes Region, I rely on Fast Passport Center for all my passport needs. Professional, reliable, and always on time.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "franklin-nh-1",
      name: "Franklin Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "51 Central St",
      city: "Franklin",
      state: "NH",
      zip: "03235",
      phone: "(603) 934-4241",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.2 miles from downtown Franklin",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Franklin. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "franklin-nh-2",
      name: "Tilton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10 E Main St",
      city: "Tilton",
      state: "NH",
      zip: "03276",
      phone: "(603) 286-4621",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "0.3 miles from downtown Tilton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for northern Merrimack County residents. Limited hours — book appointments well in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "franklin-nh-3",
      name: "Laconia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "48 N Main St",
      city: "Laconia",
      state: "NH",
      zip: "03246",
      phone: "(603) 524-4730",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from downtown Laconia",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for Lakes Region residents. Extended passport hours. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "franklin-nh-4",
      name: "Concord Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "18 Loews Dr",
      city: "Concord",
      state: "NH",
      zip: "03301",
      phone: "(603) 224-0631",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "1.5 miles from downtown Concord",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for southern Merrimack County residents. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "franklin-nh-5",
      name: "Franklin City Clerk",
      type: "City Clerk Passport Acceptance",
      address: "316 Central St",
      city: "Franklin",
      state: "NH",
      zip: "03235",
      phone: "(603) 934-5444",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.1 miles from City Hall",
      website: "https://www.franklinnh.org/",
      websiteLabel: "Franklin City Clerk",
      notes: "Major municipal facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
    {
      id: "franklin-nh-6",
      name: "Sanbornton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1070 Sanbornton Rd",
      city: "Sanbornton",
      state: "NH",
      zip: "03269",
      phone: "(603) 286-7228",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "0.4 miles from downtown Sanbornton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves western Merrimack County near the Lakes Region. Limited passport hours — call to confirm.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — downtown Boston", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Franklin photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Merrimack County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Franklin applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Franklin families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Franklin travelers often assume standard processing will be fine. It takes 6–13 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Franklin." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Franklin address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Franklin before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Franklin for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround for most central New Hampshire travelers." },
    { q: "How fast can I renew my passport in Franklin?", a: "Fast Passport Center offers fast passport renewal in Franklin in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. We can expedite your passport renewal in Franklin in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Franklin?", a: "Same-day passport appointments are only available at the Boston Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Franklin residents." },
    { q: "Can I expedite a child passport in Franklin?", a: "Yes. Fast Passport Center expedites child passports in Franklin for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Franklin with DS-64 form guidance. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Franklin?", a: "With Fast Passport Center's emergency courier service, Franklin travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to visit the Boston Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Franklin?", a: "Popular options include the Franklin Post Office (03235), Tilton Post Office (03276), Laconia Post Office (03246), Concord Post Office (03301), Franklin City Clerk (03235), and Sanbornton Post Office (03269). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Franklin?", a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option." },
    { q: "What if I live in a nearby town like Tilton or Northfield?", a: "We serve all of central New Hampshire including Tilton, Northfield, Sanbornton, Hill, Andover, Salisbury, Boscawen, Canterbury, Loudon, Pittsfield, Epsom, Chichester, Pembroke, Concord, Laconia, Belmont, Gilford, New Hampton, and Wilmot. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Franklin?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Franklin", address: "55 Central St, Franklin, NH 03235", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Laconia", address: "135 N Main St, Laconia, NH 03246", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Rite Aid — Tilton", address: "10 E Main St, Tilton, NH 03276", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart — Tilton", address: "33 Tilton Rd, Tilton, NH 03276", hours: "Mon–Sun: 6AM–11PM" },
    { name: "UPS Store — Laconia", address: "66 N Main St, Laconia, NH 03246", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Shaw's — Franklin", address: "45 Central St, Franklin, NH 03235", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Hannaford — Laconia", address: "20 N Main St, Laconia, NH 03246", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Dollar General — Tilton", address: "8 W Main St, Tilton, NH 03276", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    { name: "DMV — Franklin", address: "51 Central St, Franklin, NH 03235", hours: "Mon–Fri: 8AM–5PM", note: "Full-service center for central New Hampshire residents. Appointment recommended.", featured: true },
    { name: "DMV — Laconia", address: "48 N Main St, Laconia, NH 03246", hours: "Mon–Fri: 8AM–5PM", note: "Passport-ready photo services available. Online appointment booking.", featured: false },
    { name: "DMV — Tilton", address: "11 E Main St, Tilton, NH 03276", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID processing. Walk-ins limited — book online first.", featured: false },
    { name: "DMV — Concord", address: "23 Hazen Dr, Concord, NH 03301", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV for Merrimack County residents.", featured: true },
  ],
  airports: [
    { code: "MHT", name: "Manchester-Boston Regional Airport", distance: "50 miles from Franklin", address: "1 Airport Rd, Manchester, NH 03103", note: "Closest major commercial airport for Franklin travelers. International flights to Canada and Europe.", flightUrl: "https://www.flymanchester.com/", flightLabel: "MHT Flight Info", featured: true },
    { code: "LCI", name: "Laconia Municipal Airport", distance: "12 miles from Franklin", address: "65 Airport Rd, Gilford, NH 03249", note: "Regional airport for general aviation and charter flights near the Lakes Region.", flightUrl: "https://www.laconiaairport.org/", flightLabel: "Laconia Airport", featured: false },
    { code: "BOS", name: "Boston Logan International Airport", distance: "95 miles from Franklin", address: "1 Harborside Dr, Boston, MA 02128", note: "Major international hub for long-haul flights to Europe, Asia, and South America. Accessible via I-93.", flightUrl: "https://www.massport.com/logan-airport", flightLabel: "Logan Airport", featured: false },
  ],
};